import React, { useState } from 'react';
import { IAddFriendRequestPayload, IFriend } from '../../types/friend';
import ButtonPrimary from '../button-refactor/button-primary';
import { Link, useNavigate } from 'react-router-dom';
import { userService } from '../../services/user.service';
import _size from 'lodash/size';
import classNames from 'classnames';
import { EmptyComponent } from '../empty/empty-component';
import ButtonSecondary from '../button-refactor/button-secondary';
import { useSelector } from 'react-redux';
import { RootState } from '../../configuration';

interface ListFriendRequestProps {
  data: IFriend[];
  userId: string;
  onSuccess: () => void;
  listFriendPage?: boolean;
  hiddenAddFriend?: boolean;
}

const ListFriendRequest = ({
  data,
  userId,
  onSuccess,
  listFriendPage,
  hiddenAddFriend,
}: ListFriendRequestProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const userProfile = useSelector(
    (state: RootState) => state.features.auth.profile
  );

  const navigator = useNavigate();

  const acceptFriend = async (payload: IAddFriendRequestPayload) => {
    try {
      setLoading(true);
      await userService.addFriend(payload);
      setSuccess(true);

      onSuccess();
    } catch (error) {
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  const onAddFriend = (user: IFriend) => {
    const payload: IAddFriendRequestPayload = {
      requestUserId: user.userId,
      acceptStatus: 'ACCEPTED',
      userId,
    };

    acceptFriend(payload);
  };

  if (!_size(data)) {
    return <EmptyComponent />;
  }

  return (
    <div
      className={classNames(`grid gap-[6px] xl:grid-cols-2`, {
        '2xl:grid-cols-2': !listFriendPage,
        'xl:grid-cols-2 2xl:grid-cols-3': listFriendPage,
      })}
    >
      {data.map((item) => (
        <div key={item.userId}>
          <div
            className="rounded-lg flex items-center gap-3 border border-[#DEE0E6] dark:border-slate-700 w-full bg-white dark:bg-zinc-800 p-2
            "
          >
            <Link
              to={
                userProfile?.userId === item.userId
                  ? '/profile'
                  : `/user/${item.userName}`
              }
            >
              <img
                src={
                  item.avatar ||
                  '/default-avatar.svg'
                }
                alt={item.fullName}
                className="2xl:max-w-[120px] max-w-[76px] w-full bg-white rounded-lg aspect-square object-cover"
                onError={(e) => {
                  e.currentTarget.src =
                    '/default-avatar.svg';
                }}
              />
            </Link>
            <div className="flex flex-col gap-[6px]">
              <Link
                to={
                  userProfile?.userId === item.userId
                    ? '/profile'
                    : `/user/${item.userName}`
                }
              >
                <h3 className="font-semibold text-[#111827]  dark:text-slate-50 text-sm">
                  {item.fullName}
                </h3>
              </Link>

              {!hiddenAddFriend ? (
                <div className="flex gap-2">
                  <ButtonSecondary className="w-fit h-[23px] px-2 flex justify-center items-center py-0 !rounded !border-[#DEE0E6] dark:border-slate-700 font-semibold !text-xs ">
                    Xóa bỏ
                  </ButtonSecondary>
                  <ButtonPrimary
                    className="w-fit h-[23px] px-2 items-center justify-center !bg-[#0057FF] !rounded text-white !text-xs "
                    onClick={() => onAddFriend(item)}
                  >
                    Chấp nhận
                  </ButtonPrimary>

                  {/* <ButtonSecondary className="w-full flex justify-center mt-3">Từ chối</ButtonSecondary> */}
                </div>
              ) : (
                userProfile?.userId !== item.userId && (
                  <div className=" flex gap-2">
                    <ButtonSecondary
                      onClick={() => navigator(`/chat?id=${item.userId}`)}
                      className="w-fit  px-2 flex justify-center items-center py-1 !rounded !border-[#DEE0E6] dark:border-slate-700 font-semibold !text-xs "
                    >
                      Nhắn tin
                    </ButtonSecondary>

                    <ButtonPrimary
                      onClick={() => {
                        navigator(`/user/${item.userName}`);
                      }}
                      className="w-fit px-2 items-center justify-center !bg-[#0057FF] py-1 !rounded text-white !text-xs "
                    >
                      Bạn bè
                    </ButtonPrimary>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListFriendRequest;
